import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const $ = jQuery;

$( () => {

    $('.hero-slider .swiper').each(function () {
        var t = $(this);

        if (t.find('.swiper-slide').length > 1) {
            var s = new Swiper(this, {
                autoHeight: true,
                grabCursor: true,
                paginationClickable: true,
                loop: true,
                speed: 500,
                observer: true,
                observeParents: true,
                modules: [Pagination, Autoplay],
    
                /* autoplay: {
                    delay: 5000
                }, */
    
                pagination: {
                    el: t.parent().find('.swiper-pagination')[0],
                    clickable: true
                },
            });
        } else {
            t.parent().addClass('single-slide');
        }
    });

    if ($('.ce-hero-slider:first-child:not(.is-inline)').length) {
        $(window).scroll(function () {

            let scr = $(window).scrollTop() / 4;
            if(scr < 0) {
                scr = 0;
            }
            $('.hero-slider .media-bgr-wrapper img').css('transform', 'translateY(' + scr + 'px)');

        }).scroll();
    }

    $('.img-slider .swiper').each(function () {
        var t = $(this);

        if (t.find('.swiper-slide').length > 1) {
            var s = new Swiper(this, {
                autoHeight: true,
                grabCursor: true,
                paginationClickable: true,
                loop: true,
                speed: 500,
                observer: true,
                observeParents: true,
                modules: [Navigation, Pagination],

                pagination: {
                    el: t.parent().find('.swiper-pagination')[0],
                    clickable: true
                },

                navigation: {
                    nextEl: t.parent().find('.swiper-button-next')[0],
                    prevEl: t.parent().find('.swiper-button-prev')[0]
                },
            });
        } else {
            t.parent().addClass('single-slide');
        }
    });

    $('.testimonial-slider .swiper').each(function () {
        var t = $(this);

        if (t.find('.swiper-slide').length > 1) {
            var s = new Swiper(this, {
                autoHeight: true,
                grabCursor: true,
                paginationClickable: true,
                loop: true,
                speed: 500,
                observer: true,
                observeParents: true,
                modules: [Pagination, Autoplay],

                /* autoplay: {
                    delay: 5000
                }, */
    
                pagination: {
                    el: t.parent().find('.swiper-pagination')[0],
                    clickable: true
                },
            });
        } else {
            t.parent().addClass('single-slide');
        }
    });

    $('.ce-teaser-slider.is-twocol .swiper-container').each(function () {
        var t = $(this);

        var sw = new Swiper(this, {
            paginationClickable: true,
            slidesPerView: 2,
            spaceBetween: 20,
            speed: 500,
            autoHeight: false,
            observer: true,
            observeParents: true,
            modules: [Navigation],

            navigation: {
                nextEl: t.parent().parent().find('.swiper-button-next')[0],
                prevEl: t.parent().parent().find('.swiper-button-prev')[0]
            },

            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                992: {
                    slidesPerView: 3,
                    /* spaceBetween: 30 */
                }
            }

        });
    });


    $('.ce-teaser-slider.is-threecol .swiper-container').each(function () {
        var t = $(this);

        var sw = new Swiper(this, {
            paginationClickable: true,
            slidesPerView: 3,
            spaceBetween: 20,
            speed: 500,
            autoHeight: false,
            observer: true,
            observeParents: true,
            modules: [Navigation],

            navigation: {
                nextEl: t.parent().parent().find('.swiper-button-next')[0],
                prevEl: t.parent().parent().find('.swiper-button-prev')[0]
            },

            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                992: {
                    slidesPerView: 3,
                    /* spaceBetween: 30 */
                }
            }

        });
    });


    $('.ce-teaser-slider.is-fourcol .swiper-container').each(function () {
        var t = $(this);

        var sw = new Swiper(this, {
            paginationClickable: true,
            slidesPerView: 4,
            spaceBetween: 20,
            speed: 500,
            autoHeight: false,
            observer: true,
            observeParents: true,
            modules: [Navigation],

            navigation: {
                nextEl: t.parent().parent().find('.swiper-button-next')[0],
                prevEl: t.parent().parent().find('.swiper-button-prev')[0]
            },

            breakpoints: {
                320: {
                    slidesPerView: 1.2,
                    spaceBetween: 16
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 20
                },
                1200: {
                    slidesPerView: 4,
                    /* spaceBetween: 30 */
                }
            }

        });
    });

} );